<i18n>
  {
    "fr": {
    },
    "en": {
    }
  }
</i18n>

<template>
  <div>TODO</div>
</template>

<script>
export default {
  name: 'Transition1point5'
}
</script>
